import React from "react";
import { DisabledPrompt, Link, useModel, useRoute, useParams } from "@bcm-dev/bcms-vite";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";

import "./styles.css";

/**
 * @function ReplaceCardAddressView
 * @param {STRING} address - Sets the address
 * @param {STRING} city - Sets the city name
 * @param {STRING} state - Sets the state
 * @param {STRING} zip - Sets the zip code
 * @return {React.Component}
 * @exported true
 * @description The main component for ReplaceCardAddressView
 */
export default function ReplaceCardAddressView(props) {
    const { user } = useModel();
    const cardID = useParams().cardID ?? "0";
    const navigate = useRoute();

    const next = evt => navigate(`/home/replacemycard/replacecardconfirm/${ cardID }`);
    const cancel = evt => navigate(`/home/recenttransactions/${ cardID }`);
    const report = `/home/reportloststolen/report/${ cardID }`;

    return (
        <div className="replace-card-address-view text-center">
            <div className="text-block">
                <span>If your card is missing, </span>
                <Link to={ report }>Report lost or stolen</Link>
            </div>
            <p>Your new card will be sent to the following address.</p>
            <div className="address-container">
                <p>{user.street},</p>
                <p>{user.city},</p>
                <p>{user.state} - {user.zip}</p>
            </div>
            <div className="text-block">
                <span>Has your address changed? </span>
                    <DisabledPrompt>
                        <Link>Contact Us</Link>
                    </DisabledPrompt>
            </div>
            <UIPrimaryButton text="Next" onClick={next} />
            <UICancelButton text="Cancel" onClick={cancel} />
        </div>
    )
}
